export default __webpack_public_path__ + "static/media/account-circle-fill.19a493c3.svg";